// Конвертация числа в текст по-украински (для бух.документов).
// Поддерживает суммы до триллионов; копейки — в формате "ХХ коп.".

const ONES_M = ['', 'один', 'два', 'три', 'чотири', "п'ять", 'шість', 'сім', 'вісім', "дев'ять"];
const ONES_F = ['', 'одна', 'дві', 'три', 'чотири', "п'ять", 'шість', 'сім', 'вісім', "дев'ять"];
const TEENS = ['десять', 'одинадцять', 'дванадцять', 'тринадцять', 'чотирнадцять',
  "п'ятнадцять", 'шістнадцять', 'сімнадцять', 'вісімнадцять', "дев'ятнадцять"];
const TENS = ['', '', 'двадцять', 'тридцять', 'сорок', "п'ятдесят",
  'шістдесят', 'сімдесят', 'вісімдесят', "дев'яносто"];
const HUNDREDS = ['', 'сто', 'двісті', 'триста', 'чотириста', "п'ятсот",
  'шістсот', 'сімсот', 'вісімсот', "дев'ятсот"];

function _group(n: number, feminine: boolean): string {
  // n: 0..999
  const ones = feminine ? ONES_F : ONES_M;
  const parts: string[] = [];
  const h = Math.floor(n / 100);
  const rest = n % 100;
  if (h > 0) parts.push(HUNDREDS[h]!);
  if (rest >= 10 && rest < 20) parts.push(TEENS[rest - 10]!);
  else {
    const t = Math.floor(rest / 10);
    const o = rest % 10;
    if (t > 0) parts.push(TENS[t]!);
    if (o > 0) parts.push(ones[o]!);
  }
  return parts.join(' ');
}

function _morph(n: number, [one, few, many]: [string, string, string]): string {
  const last = n % 100;
  if (last >= 11 && last <= 14) return many;
  switch (last % 10) {
    case 1: return one;
    case 2: case 3: case 4: return few;
    default: return many;
  }
}

const MILLION_FORMS: [string, string, string] = ['мільйон', 'мільйони', 'мільйонів'];
const THOUSAND_FORMS: [string, string, string] = ['тисяча', 'тисячі', 'тисяч'];
const HRYVNIA_FORMS: [string, string, string] = ['гривня', 'гривні', 'гривень'];

export function amountToWordsUA(amount: number | string): string {
  const num = typeof amount === 'string' ? Number(amount) : amount;
  const total = Math.round(num * 100);
  const hrn = Math.floor(total / 100);
  const kop = total % 100;

  const parts: string[] = [];
  const millions = Math.floor(hrn / 1_000_000);
  const thousands = Math.floor((hrn % 1_000_000) / 1000);
  const ones = hrn % 1000;

  if (millions > 0) {
    parts.push(_group(millions, false));
    parts.push(_morph(millions, MILLION_FORMS));
  }
  if (thousands > 0) {
    parts.push(_group(thousands, true));  // тысячи — женский род
    parts.push(_morph(thousands, THOUSAND_FORMS));
  }
  if (ones > 0 || hrn === 0) {
    parts.push(_group(ones, true));  // гривны — женский род
  }

  const hrnWord = _morph(hrn, HRYVNIA_FORMS);
  const kopStr = String(kop).padStart(2, '0');
  let txt = parts.filter(Boolean).join(' ');
  if (txt.length > 0) txt = txt[0]!.toUpperCase() + txt.slice(1);
  else txt = 'Нуль';
  return `${txt} ${hrnWord} ${kopStr} коп.`;
}

/** Ціле число прописом («Дев'ять», «Двадцять сім») — кількості у формах
 * інвентаризації (Наказ МФУ №572). До мільярдів включно. */
export function intToWordsUA(n: number, feminine = false): string {
  const v = Math.floor(Math.abs(n));
  if (v === 0) return 'Нуль';
  const parts: string[] = [];
  const millions = Math.floor(v / 1_000_000);
  const thousands = Math.floor((v % 1_000_000) / 1000);
  const rest = v % 1000;
  if (millions > 0) {
    parts.push(_group(millions, false));
    parts.push(_morph(millions, MILLION_FORMS));
  }
  if (thousands > 0) {
    parts.push(_group(thousands, true));
    parts.push(_morph(thousands, THOUSAND_FORMS));
  }
  if (rest > 0) parts.push(_group(rest, feminine));
  const txt = parts.filter(Boolean).join(' ');
  return txt[0]!.toUpperCase() + txt.slice(1);
}

const KOPIYKA_FORMS: [string, string, string] = ['копійка', 'копійки', 'копійок'];

/** Сума прописом у повній формі офіційних бланків:
 * «П'ять тисяч триста тридцять одна гривня 66 копійок». */
export function amountToWordsUAFull(amount: number | string): string {
  const num = typeof amount === 'string' ? Number(amount) : amount;
  const total = Math.round(Math.abs(num) * 100);
  const hrn = Math.floor(total / 100);
  const kop = total % 100;
  const hrnTxt = hrn === 0 ? 'Нуль' : intToWordsUA(hrn, true);
  return `${hrnTxt} ${_morph(hrn, HRYVNIA_FORMS)} `
    + `${String(kop).padStart(2, '0')} ${_morph(kop, KOPIYKA_FORMS)}`;
}
